import { render, staticRenderFns } from "./TimeIndicator.vue?vue&type=template&id=2176f053&scoped=true"
import script from "./TimeIndicator.vue?vue&type=script&lang=js"
export * from "./TimeIndicator.vue?vue&type=script&lang=js"
import style0 from "./TimeIndicator.vue?vue&type=style&index=0&id=2176f053&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2176f053",
  null
  
)

export default component.exports